import { Button, TextField } from "@mui/material";
import { useState } from "react";
import { sendFeedback } from "../../api/feedback-api";
import useAPIError from "../../common/hooks/useAPIError";

export default function FeedbackForm(params: {
  customer: string;
  economicProfile: string;
  url: string;
  onSuccessfulSend?: () => void;
}) {
  const [feedback, setFeedback] = useState("");
  const [contactEmail, setContactEmail] = useState("");

  const [isSending, setIsSending] = useState(false);
  const { addError, deleteError } = useAPIError();

  const onSendClick = () => {
    setIsSending(true);
    sendFeedback(
      feedback.trim(),
      contactEmail.trim() || undefined,
      params.url,
      params.customer,
      params.economicProfile
    )
      .then(() => {
        // Clear form on successful send
        setFeedback("");
        setContactEmail("");

        deleteError();

        if (params.onSuccessfulSend) {
          params.onSuccessfulSend();
        }
      })
      .catch((e) => {
        console.log("Fel:", e);
        addError("Feedback kunde inte skickas");
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <>
      <TextField
        id="feedback"
        label="Feedback"
        type="text"
        value={feedback}
        onChange={(event) => {
          setFeedback(event.target.value);
        }}
        multiline
        maxRows={15}
        required
        placeholder="Skriv vad du tycker. Berätta gärna vilka sidor feedbacken gäller."
        InputLabelProps={{
          shrink: true,
        }}
        variant="standard"
        fullWidth
        margin="normal"
        autoFocus
      />
      <TextField
        id="contactEmail"
        label="Din e-post"
        type="text"
        value={contactEmail}
        onChange={(event) => {
          setContactEmail(event.target.value);
        }}
        placeholder="Fyll i om du önskar återkoppling"
        InputLabelProps={{
          shrink: true,
        }}
        variant="standard"
        fullWidth
        margin="normal"
      />
      <Button
        disabled={!feedback.trim() || isSending}
        size="medium"
        variant="contained"
        sx={{ float: "right", marginTop: 2 }}
        onClick={onSendClick}
      >
        {!isSending ? "Skicka" : "Skickar..."}
      </Button>
    </>
  );
}
